import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { BOOKINGS_API_URL } from "../Bookings";

export const BookingConfigContext = React.createContext({
    unitId: null,
    bookingDate: null,
    category: null,
    amenity: null,
    bookingConfig: null,
    onBookingDateChange: () => {},
    onTimelineBoundaryChange: () => {}
});

const BookingConfigProvider = (props) => {
    const dispatch = useDispatch();

    // TODO - do we need to consider having a local state copy of some of these?
    const unitId = props.unitId;
    const bookingDate = props.bookingDate;
    const category = props.category;
    const amenity = props.amenity;
    const [localBookingConfig, setLocalBookingConfig] = useState(null);

    useEffect(() => {
        setLocalBookingConfig(props.bookingConfig);
    }, [props.bookingConfig]);

    const handleBookingDateChange = (newDate) => {
        props.onBookingDateChange(newDate);
    }

    const handleTimelineBoundaryChange = async (newBoundary) => {
        const result = await axios.get(`${BOOKINGS_API_URL}categories/${amenity.url}`, {
            params: {
                date: bookingDate,
                boundaryStart: newBoundary.start,
                boundaryEnd: newBoundary.end,
                unitId: unitId,
                editingThisBookingId: null
            }
        });

        setLocalBookingConfig(result.data.config);
    }

    return (
        <BookingConfigContext.Provider
            value={{
                unitId,
                bookingDate,

                category,
                amenity,
                bookingConfig: localBookingConfig,

                onBookingDateChange: handleBookingDateChange,
                onTimelineBoundaryChange: handleTimelineBoundaryChange,
            }}
        >
            {props.children}
        </BookingConfigContext.Provider>
    )
}

export default BookingConfigProvider;
